import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getSelectedZusatzoptionen,
  GlobalActions,
  GlobalPut,
  TkvCheckoutProduktPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { TkvActions } from '../tkvActions';
import {
  convertToBffTierart,
  convertToBffTiergeschlecht,
  convertToBffTierhaltung,
} from './transformer/tkvData.transformer';

export function* watchInDashboardUebernehmenSaga() {
  yield takeEvery(TkvActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateDashboardData, App.TKV));
  yield takeEvery(TkvActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateProduktData, App.TKV));
}

export function* generateProduktData() {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();

  const produktData: TkvCheckoutProduktPayload = {
    appId: App.TKV,
    angebotsId: state.angebotsId,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    uebersichtTitle: 'Tierkrankenversicherung',
    versichertesRisiko: `${state.versicherungsnehmer.rasse.label}, geb. ${state.versicherungsnehmer.geburtsdatumTier}`,
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    vorvertragSofortschutz: state.vertragsoptionen.vorvertragSofortschutz,
    tierart: convertToBffTierart(state.versicherungsnehmer.tierart),
    inBehandlung: state.versicherungsnehmer.isBehandelt,
    rasse: state.versicherungsnehmer.rasse,
    geburtsdatumTier: state.versicherungsnehmer.geburtsdatumTier,
    beginndatum: state.vertragsoptionen.beginnDatum,
    geschlecht: convertToBffTiergeschlecht(state.versicherungsnehmer.geschlecht),
    tierhaltung: convertToBffTierhaltung(state.versicherungsnehmer.katzenhaltung),
    isTierKastriert: state.versicherungsnehmer.isTierKastriert,
    angebotsdatum: state.vertragsoptionen.angebotsdatum,
  };

  if (state.versicherungsnehmer.tiername) {
    produktData.tiername = state.versicherungsnehmer.tiername;
  }
  if (state.versicherungsnehmer.einsatzgebiet) {
    produktData.einsatzgebiet = state.versicherungsnehmer.einsatzgebiet;
  }
  if (state.versicherungsnehmer.kennzeichnungsArt) {
    produktData.kennzeichnungsArt = state.versicherungsnehmer.kennzeichnungsArt;
  }
  if (state.versicherungsnehmer.kennzeichen) {
    produktData.kennzeichen = state.versicherungsnehmer.kennzeichen;
  }
  if (state.versicherungsnehmer.diagnose) {
    produktData.previousDiagnoses = state.versicherungsnehmer.diagnose;
  }
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktData));
}

export function* generateDashboardData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);

  yield put(new TkvActions().vorschlagdatenChanged());

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().inDashboardUebernehmen({
      appId: App.TKV,
      angebotsId: state.angebotsId,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      versichertesRisiko: getVersichertesRisiko(state),
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      beginn: state.vertragsoptionen.beginnDatum,
      selectZusatzoptionen: getSelectedZusatzoptionen(selectedProduktlinie.zusatzoptionen),
      tierart: state.versicherungsnehmer.tierart,
    }),
  );
}

export const getVersichertesRisiko = (state: IAppState) =>
  `${state.versicherungsnehmer.rasse.label}, ${state.versicherungsnehmer.geburtsdatumTier}`;
